import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logoNew.svg'


const _withScopeId = n => (_pushScopeId("data-v-797e8a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog__wrapper mediaRequestModel__wrapper" }
const _hoisted_2 = { class: "btn__close" }
const _hoisted_3 = { class: "mediaRequestModel__content" }
const _hoisted_4 = { class: "mediaRequestModel__title" }
const _hoisted_5 = { class: "mediaRequestModel__text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mediaRequestModel__img" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = {
  class: "download",
  for: "cv"
}
const _hoisted_8 = {
  key: 0,
  class: "upload"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDialog) = $event)),
    onKeyup: _withKeys(_ctx.onClose, ["esc"]),
    class: "landing-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_btn, {
            "no-caps": "",
            icon: "close",
            style: {"color":"#999CA1"},
            flat: "",
            round: "",
            onClick: _ctx.onClose
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('mediaBuying.request.title')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('mediaBuying.request.subtitle')), 1),
          _hoisted_6
        ]),
        _createVNode(_component_q_form, {
          onChange: _cache[4] || (_cache[4] = 
          () => {
            this.errors.cv = ''
          }
        ),
          class: "mediaRequestModel__form",
          onSubmit: _ctx.submitRequest
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_input, {
              outlined: "",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              name: "name",
              type: "text",
              label: "Name",
              "label-color": "white",
              "lazy-rules": "",
              rules: [_ctx.requiredField, _ctx.baseValidation]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_q_input, {
              outlined: "",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phone) = $event)),
              name: "phone",
              type: "text",
              label: "Phone",
              "label-color": "white",
              "lazy-rules": "",
              rules: [_ctx.requiredField, _ctx.baseValidation]
            }, null, 8, ["modelValue", "rules"]),
            _createVNode(_component_q_input, {
              outlined: "",
              modelValue: _ctx.telegram,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telegram) = $event)),
              name: "telegram",
              type: "text",
              label: "Telegram",
              "label-color": "white",
              "lazy-rules": "",
              rules: [_ctx.requiredField, _ctx.baseValidation]
            }, null, 8, ["modelValue", "rules"]),
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.cv ? 'Загружено' : 'Загрузить резюме'), 1),
            _createElementVNode("input", {
              id: "cv",
              type: "file",
              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFileUpload && _ctx.onFileUpload(...args)))
            }, null, 32),
            (_ctx.errors.cv)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errors.cv), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_Button, {
              style: {"font-size":"20px","line-height":"20px"},
              centered: "",
              class: "btn__submit",
              type: "submit",
              text: this.$t('mediaBuying.request.btn')
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onKeyup"]))
}